import { sendMessage } from './apiRoutes';

let submitHandler = null;
let composer = null;
let textarea = null;
let chatId = null;

export function activate({ aiChatId } = {}) {
  composer = document.getElementById('chatkit-v2-composer');
  if (!composer) return;

  textarea = composer.querySelector('textarea[name="ai_message[content]"]');
  if (!textarea) return;

  chatId = aiChatId;

  submitHandler = async (event) => {
    event.preventDefault();
    const content = textarea.value.trim();
    if (!content || !chatId) return;

    textarea.value = '';
    await sendMessage({ chatId, content });
  };

  composer.addEventListener('submit', submitHandler);
}

export function deactivate() {
  if (composer && submitHandler) {
    composer.removeEventListener('submit', submitHandler);
  }
  submitHandler = null;
  composer = null;
  textarea = null;
  chatId = null;
}
